<script setup lang="ts">
  interface Props {
    modelValue: number;
  }

  defineProps<Props>();

  const emit = defineEmits<{
    (e: 'update:modelValue', value: number): void;
  }>();

  const widths = [1, 2, 3, 4, 5] as const;
</script>

<template>
  <div class="border-width-picker">
    <button
      v-for="width in widths"
      :key="width"
      v-tippy="{
        content: `${width}px`,
        placement: 'top',
        theme: 'custom',
        trigger: 'mouseenter',
        hideOnClick: true,
      }"
      type="button"
      :class="['border-width-btn', modelValue === width ? 'active' : '']"
      :aria-label="`${width}px`"
      @click="emit('update:modelValue', width)"
    >
      <span
        class="border-width-preview"
        :style="{ height: `${width}px` }"
      />
    </button>
  </div>
</template>

<style scoped>
  .border-width-picker {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 8px;
    min-width: 80px;
  }

  .border-width-btn {
    display: flex;
    align-items: center;
    height: 28px;
    padding: 0 8px;
    border: none;
    background: transparent;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.15s ease;
  }

  .border-width-btn:hover {
    background-color: var(--color-gray-01);
  }

  .border-width-btn.active {
    background-color: var(--color-gray-01);
  }

  .border-width-preview {
    display: block;
    width: 100%;
    background-color: var(--color-gray-07);
    border-radius: 1px;
  }

  .border-width-btn.active .border-width-preview {
    background-color: var(--theme-secondary, #fb7185);
  }
</style>
